import { render, staticRenderFns } from "./RealEstateList.vue?vue&type=template&id=a23a5866&scoped=true&"
import script from "./RealEstateList.vue?vue&type=script&lang=js&"
export * from "./RealEstateList.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateList.vue?vue&type=style&index=0&id=a23a5866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23a5866",
  null
  
)

export default component.exports